/* eslint-disable space-infix-ops */
/* eslint-disable indent */
/* eslint-disable no-confusing-arrow */
import styled, { css } from 'styled-components';
import uiDevice from '@deprecated-ui/_style/device';

interface IContainer {
  isFlexibleWidth: boolean;
  isSideWidgetOpen?: boolean;
  maxWidth: number;
  fullPage?: boolean;
  isMarketOpen?: boolean;
}
interface IWrapper {
  background?: string;
  isSideWidgetOpen?: boolean;
}

interface IWrapperContent {
  isSideWidgetOpen?: boolean;
  isMarketOpen?: boolean;
}

// TODO: Update device dimension to DS
const laptopM = '(min-width:1081px)';
export const device = { ...uiDevice, laptopM };
export const SIDE_WIDGET_CONTENT_WIDTH = '330px';
export const SIDE_WIDGET_TOOLBAR_WIDTH = '35px';
export const SIDE_WIDGET_OPENED_WIDTH = '365px';

// prettier-ignore
const Container = styled.main<IContainer>`
  margin: 40px auto 0 auto;
  padding: ${(props) => (props.fullPage ? '0' : '20px 0')};
  width: 100%;
  max-width: ${(props) => (props.maxWidth ? `${props.maxWidth}px` : '990px')};

  &.chat-expanded {
    margin: 0 auto 0 auto !important;
    padding: 0 !important;
  }

  ${(props) =>
    props.isFlexibleWidth &&
    css`
      @media ${device.tablet} {
        width: ${props.isMarketOpen
          ? 'calc(100% - 60px)'
          : 'calc(100% - 100px)'};
      }
    `}

  @media ${device.tablet} {
    margin: 100px auto 0;
    max-width: ${(props) => (props.maxWidth ? `${props.maxWidth}px` : '660px')};

    &.chat-expanded {
      margin: 0px auto 0 auto !important;
      padding: 20px 37px 0 0 !important;
    }
  }

  @media ${device.laptopM} {
    max-width: ${(props) => (props.maxWidth ? `${props.maxWidth}px` : '990px')};
    &:has(#academy-iframe) {
      position: absolute !important;
      left: 0;
      padding-bottom: 0;
      width: 100% !important;
      max-width: ${({ isSideWidgetOpen, isMarketOpen }) =>
        (() => {
          if (!isSideWidgetOpen) {
            return 'unset';
          }
          if (!isMarketOpen) {
            return 'calc(100% - 425px) !important';
          }
          return 'calc(100% - 365px) !important';
        })()};
      margin: ${({ isSideWidgetOpen }) => isSideWidgetOpen && 'auto !important'};
    }
  }

  @media screen and (min-width: 1500px) {
    margin: 100px auto 0 auto;
    position: ${({ isSideWidgetOpen }) =>
      isSideWidgetOpen ? 'absolute' : 'none'};
    right: ${({ isSideWidgetOpen }) =>
      isSideWidgetOpen ? 'calc(-310px + 50vw)' : 'none'};

    &:has(#chat-container) {
      left: calc(-310px + 30vw) !important;
    }
  }
`;

export const Wrapper = styled.div<IWrapper>`
  background: ${(props) =>
    props.background ? props.background : 'transparent'};
  width: 100%;
  /* margin: auto;

  @media ${device.tablet} {
    width: calc(100% - ${SIDE_WIDGET_TOOLBAR_WIDTH});
  } */
`;

export const WrapperMainContent = styled.div<IWrapperContent>`
  width: ${({ isSideWidgetOpen, isMarketOpen }) =>
    (() => {
      if (!isSideWidgetOpen) {
        return `calc(100% - ${SIDE_WIDGET_TOOLBAR_WIDTH}) `;
      }
      if (!isMarketOpen) {
        return 'calc(100% - 425px)';
      }
      return 'calc(100% - 365px)';
    })()};
`;

export default Container;
